import { createContext, PropsWithChildren } from 'react';

export interface HorizontalScrollContextType {
  horizontalScroll: boolean;
}

export const HorizontalScrollContext = createContext<HorizontalScrollContextType>({
  horizontalScroll: false,
});

interface HorizontalScrollContextProviderProps {
  horizontalScroll: boolean;
}

export default function HorizontalScrollContextProvider({
  horizontalScroll,
  children,
}: PropsWithChildren<HorizontalScrollContextProviderProps>) {
  return <HorizontalScrollContext.Provider value={{ horizontalScroll }}>{children}</HorizontalScrollContext.Provider>;
}
